import React from "react";
import { SchedulerViewComponentProps } from "../../types/views";

const MapView: React.FC<SchedulerViewComponentProps> = () => {
  return (
    <div className="h-full bg-white p-6">
      <div className="rounded-lg border border-dashed border-gray-300 p-6 text-sm text-gray-500">
        Map rendering is handled by the Dispatch workspace panel.
      </div>
    </div>
  );
};

export default MapView;
